import React from "react"
import "./footer.css"
import {AiOutlineMail, AiOutlineTwitter, AiFillLinkedin, AiOutlineGithub} from "react-icons/ai"

const Footer = () => {
  return (
    <footer>
      <a href="/#" className="footer__logo">DEV GOEL</a>
      <ul className="permalinks">
        <li><a href="/#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="mailto:goeldev01@gmail.com" target="_blank" rel="noreferrer"><AiOutlineMail /></a>
        <a href="https://twitter.com/goeldev01" target="_blank" rel="noreferrer"><AiOutlineTwitter /></a>
        <a href="https://www.linkedin.com/in/dev-goel-833a25197/" target="_blank" rel="noreferrer"><AiFillLinkedin /></a>
        <a href="https://github.com/devgoel186" target="_blank" rel="noreferrer"><AiOutlineGithub /></a>
      </div>

      {/* <div className="footer__copyright">
        <small>&copy; DEV GOEL</small>
      </div> */}
    </footer>
  )
}

export default Footer;